// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.trend-box[data-v-4da7b997] {\n  min-width: 140px;\n  min-height: 120px;\n}\n.trend-box-side[data-v-4da7b997] {\n  min-width: 100px;\n}", ""]);
// Exports
module.exports = exports;
